/**
 * 区分 embedType（forms.embed_type）
 * 出典：仕様書 9 章
 */
export const EMBED_TYPE_VALUES = ['embed', 'widget', 'api'] as const;

export type EmbedType = (typeof EMBED_TYPE_VALUES)[number];

export const EMBED_TYPE_LABELS: Readonly<Record<EmbedType, string>> = {
  embed: '貼るだけ',
  widget: 'デザインを馴染ませる',
  api: '自由に作る',
};
